import { CREATE_OR_UPDATE_NPI_AND_TIN_URL, DETAIL_NPI_AND_TIN_URL, DETAIL_NPI_AND_TIN_URL1, ENABLE_OR_DISABLE_NPI_AND_TIN_URL, EXPORT_NPI_AND_TIN_URL, GET_NPI_AND_TIN_URL, IMPORT_NPI_AND_TIN_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getNpiAndTinList = (page, limit, search={}) => onResponse => {
    try {
        const {clients,facility,partner,is_active} = search
        axiosInstance.get(GET_NPI_AND_TIN_URL, {
            params: {
                page: page,
                limit: limit,
                client: Array.isArray(clients)? clients?.join(','):"",
                facility: Array.isArray(facility)? facility?.join(','):"",
                partner: Array.isArray(partner)? partner?.join(','):"",
                is_active:is_active
            }
        })

            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

        }

};

export const createOrUpdateNpiAndTin = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_OR_UPDATE_NPI_AND_TIN_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSingleNpiAndTinDetail = ({id,page,limit}) => onResponse => {
    try {
        axiosInstance.post(
  DETAIL_NPI_AND_TIN_URL,
 {tin_id: id},
  { params: { page, limit } } 
)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getNpiData = ({id,page,limit}) => onResponse => {
    try {
        axiosInstance.get(
  DETAIL_NPI_AND_TIN_URL1,
  
  { params: { tin_id: id,page, limit } } // Query params
)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const exportNpiAndTinList = (search = {}, ids = "") => onResponse => {
    try {
        const {clients,facility,partner,is_active} = search
        axiosInstance.get(EXPORT_NPI_AND_TIN_URL, {
            params: {
                client: Array.isArray(clients)? clients?.join(','):"",
                facility: Array.isArray(facility)? facility?.join(','):"",
                partner: Array.isArray(partner)? partner?.join(','):"",
                is_active:is_active,
                ids:ids,
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const importNpiAndTin = (props) => onResponse => {
    try {
        axiosInstance.post(IMPORT_NPI_AND_TIN_URL, props?.formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const enableOrDisableNpiTin = (id) => onResponse => {
    try {
        axiosInstance.post(ENABLE_OR_DISABLE_NPI_AND_TIN_URL, {
            tin_id: id

        })
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) {

    }
} 